import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-logo">BeReliable Insurance</h3>
          <p className="footer-tagline">Be Reliable, Be Secure</p>
          <p className="footer-description">
            Your trusted insurance partner in Vadodara, Gujarat. We provide comprehensive insurance solutions with transparency, efficiency, and trust.
          </p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/claims">Claims</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/inquiry">Get Quote</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Our Products</h4>
          <ul className="footer-links">
            <li><Link to="/products#car">Car Insurance</Link></li>
            <li><Link to="/products#bike">Bike Insurance</Link></li>
            <li><Link to="/products#health">Health Insurance</Link></li>
            <li><Link to="/products#commercial">Commercial Insurance</Link></li>
            <li><Link to="/products#travel">Travel Insurance</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <div className="footer-contact">
            <p><FaMapMarkerAlt /> Vadodara, Gujarat, India</p>
            <p className="phone-number"><FaPhone /> +91 70417 11159, +91 88661 41159</p>
            <p><FaEnvelope /> insurance@bereliable.in</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-credit">Design & Developed By: BeReliable</p>
        <p>&copy; {new Date().getFullYear()} BeReliable Insurance. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;


